import { getIntersectionData } from './getIntersectionData'

export const checkIntersectionStaticAssets = ({
  staticAssets,
  draggableAssets,
  layers,
  shiftingDragAssets,
  offsetLayerIndex,
  isExternalSource,
  draggableBlockDuration,
  clientMousePosition,
  dragItem,
}) => {
  const result = getIntersectionData({
    staticAssets,
    draggableAssets,
    layers,
    shiftingDragAssets,
    offsetLayerIndex,
    isExternalSource,
    draggableBlockDuration,
    clientMousePosition,
    dragItem,
  })

  return {
    ...result,
  }
}
